var _style, _g, _path, _path2, _g2, _g3, _path3, _ellipse, _defs, _g4, _path4, _path5, _g5, _circle, _path6, _path7, _circle2, _g6, _g7, _g8, _g9, _g10, _g11, _g12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    xmlns: "http://www.w3.org/2000/svg",
    type: "text/css"
  }, "\n\t.st0{fill:#F7F7F7;}\n\t.st1{fill:#FCD2B1;}\n\t.st2{fill:#F2F2F2;}\n\t.st3{fill:#B6E7FF;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#0B4870;}\n\t.st6{fill:#FFE3CA;}\n\t.st7{clip-path:url(#SVGID_2_);}\n\t.st8{fill:#2A94F4;}\n\t.st9{fill:#41AAF7;}\n\t.st10{fill:#FFBE55;}\n\t.st11{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st12{fill:#CCE9FF;}\n\t.st13{fill:#85DDFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M735.51,190.37c26.08,0.3,52.16,5.91,75.79,17.04c16.77,7.9,32,18.25,44.19,31.34   c24.38,26.19,34.01,64.52,17.37,93.29c-13.89,24.01-44.45,41.22-44.81,68.86c-0.43,32.2,40.43,53.66,76.04,60.32   c35.62,6.65,75.56,7.93,102.3,30.88c23.01,19.75,29.15,51.39,21.5,77.87c-7.65,26.49-27.01,48.53-48.57,67.37   c-54.02,47.21-123.35,78.25-194.41,102.73C634.76,791.78,471.9,817,307.86,813.92c-40.96-0.77-86.7-5.19-115.42-32.81   c-28.96-27.84-29.89-71.96-10.94-103.85s53.83-53.32,90.26-68.93s75.51-26.52,110.97-43.69c26.77-12.96,54.24-37.74,42.86-64.31   c-8.08-18.87-31.81-27.98-52.7-35.65c-29.51-10.84-58.9-23.46-83.02-42.53s-42.64-45.52-44.48-73.57   c-1.72-26.19,11.27-51.17,30.45-69.92c19.19-18.75,44.18-31.97,69.79-43.26C446.79,190.83,665.1,189.54,735.51,190.37z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "st1",
    d: "M656.96,523.47c-15.33-19.84-38.79-82.08-24.35-106.44c7.22,19.84,18.04,43.3,18.04,43.3  c-6.31-37.88,22.55-71.26,36.08-76.67c20.75,15.33,34.28,55.02,34.28,55.02s-26.16,92.91-35.18,92.91S656.96,523.47,656.96,523.47z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "st2",
    d: "M1029.08,1004.58H62.92c-5.21,0-9.47-4.26-9.47-9.47v-36.24c0-5.21,4.26-9.47,9.47-9.47h966.15  c5.21,0,9.47,4.26,9.47,9.47v36.24C1038.55,1000.32,1034.29,1004.58,1029.08,1004.58z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M436.03,978.83H126.61c-25.98,0-47.04-21.06-47.04-47.04V295.39c0-25.98,21.06-47.04,47.04-47.04h309.42   c25.98,0,47.04,21.06,47.04,47.04v636.39C483.07,957.77,462.01,978.83,436.03,978.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M432.13,956.57H130.52c-15.84,0-28.68-12.84-28.68-28.68V300.69c0-15.84,12.84-28.68,28.68-28.68h301.61   c15.84,0,28.68,12.84,28.68,28.68v627.19C460.81,943.72,447.97,956.57,432.13,956.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M166.53,269.22l18.78,23.9c7.5,9.55,18.53,15.05,30.14,15.05H345.8c11.61,0,22.64-5.51,30.14-15.05l18.78-23.9   H166.53z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M409.76,459.98c7.16-23.98-3.35-50.88-21.8-67.79c-18.45-16.91-43.53-25-68.4-27.81   c-19.57-2.21-39.76-1.39-58.35,5.08c-18.6,6.47-35.51,18.98-44.92,36.27c-10.33,18.99-10.87,41.53-12.41,63.09   c-1.54,21.56-4.94,44.49-19.3,60.64c-11.52,12.95-28.33,19.53-43.58,27.74c-22.54,12.14-42.72,28.67-59.05,48.38   c-13.06,15.76-23.85,34.01-27.49,54.15c-3.65,20.14,0.66,42.37,14.52,57.44c12.81,13.93,31.84,20.21,50.35,24.17   c18.89,4.04,38.86,6.2,57.3,0.45c20.45-6.37,36.98-21.91,49.03-39.61c12.05-17.7,20.21-37.69,29.06-57.19   c11.36-25.01,24.31-49.9,43.89-69.17c20.74-20.41,47.64-33.26,70.67-51.06c23.03-17.8,43.27-43.9,41.19-72.93"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "st5",
    d: "M438.18,503.62c-5.41-49.61-9.02-57.73-52.32-81.18c-34.07-18.45-227.65,5.88-114.73,163.95  C366.19,563.37,438.18,503.62,438.18,503.62z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    xmlns: "http://www.w3.org/2000/svg",
    transform: "matrix(0.8851 -0.4655 0.4655 0.8851 -227.2598 185.2004)",
    className: "st6",
    cx: 261.39,
    cy: 552.78,
    rx: 13.53,
    ry: 23.9
  })), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M432.13,956.57H130.52c-15.84,0-28.68-12.84-28.68-28.68V300.69c0-15.84,12.84-28.68,28.68-28.68h301.61    c15.84,0,28.68,12.84,28.68,28.68v627.19C460.81,943.72,447.97,956.57,432.13,956.57z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M470.65,939.29c-1.8,11.73-10.82,18.94-20.75,27.06c-6.49,5.3-156.18,3.73-259.1,2.01    c-54.54-0.91-95.94-1.87-95.94-1.87s-0.02-0.05-0.05-0.14c-1.02-3.38-20.61-69.79-3.91-149.74c5.12-24.53,18.79-45.21,37.36-62.38    c43.56-40.31,114.1-61.45,164.69-68.41c0,0,167.77,11.73,177.7,25.26S472.46,927.57,470.65,939.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M218.09,968.16c-13.49-0.4-117.79-1.7-123.27-1.79c-1.02-3.38-20.61-69.79-3.91-149.74    c5.12-24.53,18.79-45.21,37.36-62.38C221.7,767.91,232.3,962.96,218.09,968.16z"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "st1",
    d: "M366.92,620.88c-4.51,21.65-12.63,59.53,0,80.28c-9.92,28.86-29.77,44.2-29.77,44.2l-67.65-40.59  c0,0,46.9-74.87,29.77-104.63C304.68,585.71,366.92,620.88,366.92,620.88z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "st6",
    d: "M436.38,539.7c0,55.79-27.64,102.83-73.97,102.83S260.48,596.4,260.48,540.6s45.68-101.93,92.01-101.93  S436.38,483.91,436.38,539.7z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M444.6,533.2c-3.34-34.95-20.88-68.34-47.77-90.91c-13.15-11.03-29.31-19.77-46.47-19.44   c-19.44,0.38-36.64,12.13-52,24.05c-14.16,10.99-35.98,15.53-44.18,31.47c-8.2,15.93-16.63,76.23-5.41,90.2   c27.61-8.68,64.54-65.64,69.38-94.17C318.13,474.4,396.11,538.78,444.6,533.2z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "st10",
    cx: 266.35,
    cy: 581.65,
    r: 13.08
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "st8",
    d: "M460.81,706.31c63.96-9.65,146.05-103.46,185.74-196.37c15.33,4.51,46,12.63,46,12.63  s-37.88,294.06-256.17,287.74C404.81,741.75,460.81,706.31,460.81,706.31z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "st10",
    d: "M204,349h-68c-9.35,0-17-7.65-17-17v0c0-9.35,7.65-17,17-17h68c9.35,0,17,7.65,17,17v0  C221,341.35,213.35,349,204,349z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "st4",
    cx: 135,
    cy: 332,
    r: 7
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M156.42,339.26v-13.54h4.1v9.98h5.14v3.57H156.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M168.32,339.26v-13.54h4.1v13.54H168.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M174.15,325.71h4.65l2.93,9.12l2.92-9.12h4.65l-5,13.54h-5.16L174.15,325.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M191.05,339.26v-13.54h10.27v3.57h-6.18v1.35h6.04v3.57h-6.04v1.49h6.18v3.57H191.05z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M429.07,942h-295.5c-9.35,0-17-7.65-17-17l0,0c0-9.35,7.65-17,17-17h295.5c9.35,0,17,7.65,17,17l0,0   C446.07,934.35,438.42,942,429.07,942z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 401.5,
    cy: 925.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 413.5,
    cy: 925.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 425.5,
    cy: 925.5,
    r: 3.5
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 652,
    cy: 216,
    r: 123
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M652,214.01c20.23,0,36.63-19.92,36.63-44.49c0-24.57-5.38-44.49-36.63-44.49s-36.63,19.92-36.63,44.49    C615.37,194.09,631.77,214.01,652,214.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M582.82,281.94C582.81,280.44,582.81,281.52,582.82,281.94L582.82,281.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M721.18,283.11C721.2,282.7,721.18,280.26,721.18,283.11L721.18,283.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M721.1,280.14c-0.68-42.8-6.27-55-49.04-62.72c0,0-6.02,7.67-20.06,7.67s-20.06-7.67-20.06-7.67    c-42.31,7.64-48.24,19.65-49.02,61.33c-0.06,3.4-0.09,3.58-0.1,3.19c0,0.74,0.01,2.11,0.01,4.5c0,0,10.18,20.53,69.17,20.53    c58.99,0,69.17-20.53,69.17-20.53c0-1.53,0-2.6,0-3.33C721.16,283.35,721.14,282.88,721.1,280.14z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 906,
    cy: 458,
    r: 96
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M906,456.45c15.79,0,28.59-15.55,28.59-34.72c0-19.18-4.2-34.72-28.59-34.72s-28.59,15.55-28.59,34.72    C877.41,440.9,890.21,456.45,906,456.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M852.01,509.46C852,508.29,852,509.13,852.01,509.46L852.01,509.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M959.99,510.38C960.01,510.06,960,508.16,959.99,510.38L959.99,510.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M959.93,508.06c-0.53-33.41-4.89-42.92-38.28-48.95c0,0-4.7,5.99-15.65,5.99s-15.65-5.99-15.65-5.99    c-33.02,5.96-37.65,15.34-38.26,47.86c-0.05,2.66-0.07,2.8-0.08,2.49c0,0.58,0,1.65,0,3.51c0,0,7.95,16.02,53.99,16.02    c46.04,0,53.99-16.02,53.99-16.02c0-1.2,0-2.03,0-2.6C959.98,510.57,959.96,510.2,959.93,508.06z"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 767.5,
    cy: 698.5,
    r: 103.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M767.5,696.83c17.02,0,30.82-16.76,30.82-37.43c0-20.67-4.53-37.43-30.82-37.43s-30.82,16.76-30.82,37.43    C736.68,680.07,750.48,696.83,767.5,696.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M709.29,753.98C709.28,752.72,709.28,753.63,709.29,753.98L709.29,753.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M825.71,754.97C825.73,754.62,825.72,752.57,825.71,754.97L825.71,754.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M825.64,752.47c-0.57-36.02-5.27-46.28-41.27-52.77c0,0-5.07,6.46-16.88,6.46s-16.88-6.46-16.88-6.46    c-35.6,6.43-40.59,16.54-41.25,51.6c-0.05,2.86-0.08,3.01-0.09,2.68c0,0.62,0,1.77,0,3.78c0,0,8.57,17.28,58.21,17.28    c49.64,0,58.21-17.28,58.21-17.28c0-1.29,0-2.19,0-2.8C825.7,755.17,825.68,754.78,825.64,752.47z"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M895.58,83H747.17c-17.7,0-32.19,16.01-32.19,35.59v0c0,17.88,12.09,32.78,27.67,35.23l0.43,15.64   l15.53-15.28h136.96c17.7,0,32.19-16.01,32.19-35.59v0C927.77,99.01,913.28,83,895.58,83z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 783.16,
    cy: 119.72,
    r: 11.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 821.37,
    cy: 119.72,
    r: 11.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 859.59,
    cy: 119.72,
    r: 11.24
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M963.82,967.05c17.09,0,24.3-13.65,27.14-28.13c3.21-16.33,0.85-33.72,0.85-33.72h-56c0,0-0.09,0.66-0.21,1.85   C934.57,917.33,931.2,967.05,963.82,967.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M935.82,905.2c0,1.22,12.54,2.21,28,2.21c15.46,0,28-0.99,28-2.21c0-1.22-12.54-2.21-28-2.21   C948.35,902.99,935.82,903.98,935.82,905.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M888,749.97c0,0,29.53,44.93,47.25,72.34c17.72,27.42,22.36,33.11,24.47,41.97   c2.11,8.86,4.01,41.55,4.01,41.55h1.31c0,0-0.46-27.75-2.05-37.09c-1.54-9.03,0.11-12.27,1.38-21.76   c1.27-9.49,2.95-24.68-6.64-35.22c-9.6-10.55-7.07-20.88-10.44-27.84c-3.38-6.96-29.53-15.4-32.9-22.57   C910.99,754.19,896.23,749.76,888,749.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M888,749.97c0,0,9.28,10.55,15.61,14.13c6.33,3.59,9.28,0.42,14.13,9.07c4.85,8.65,5.04,12.44,9.48,16.87   c4.44,4.43,9.71,4.64,10.14,14.34c0.42,9.7-2.11,17.93-2.11,17.93S889.9,752.29,888,749.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M961.38,905.84h-1.32c0,0-0.4-8.98-3.96-13.34c-2.3-2.81-12.07-6.01-21.74-9.84   c-5.32-2.11-10.61-4.41-14.6-6.94c-11.23-7.14-21.94-30.13-22.86-34.22c-0.33-1.43-0.47-2.29-0.46-2.89v-0.02   c0.02-1.1,0.57-1.27,1.51-2.38c0.45-0.54,1.82-0.35,3.49,0.16c4.84,1.48,8.93,4.79,11.46,9.18c2.34,4.06,6.09,9.12,10.67,10.35   c7.93,2.12,7.27,3.43,10.2,11.5c2.92,8.06,10.29,9.38,19.53,18.89C962.57,895.79,961.38,905.84,961.38,905.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M934.36,882.66c-5.32-2.11-10.61-4.41-14.6-6.94c-11.23-7.14-21.94-30.13-22.86-34.22   c-0.33-1.43-0.47-2.29-0.46-2.89c0.03,0.27,0.55,3.91,6.41,6.33c6.07,2.51,7.26,2.51,8.05,6.34c0.79,3.83,1.46,7.93,4.63,8.72   c3.17,0.79,5.15-2.77,7.66,3.04c2.51,5.81,3.71,7.79,6.02,8.59c2.31,0.79,4.06-0.4,4.57,4.1   C934.09,878.45,934.27,881.05,934.36,882.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M971.09,905.84h1.57c0,0,3.06-55.62,7.29-60.78c2.72-3.33,11.71-9.31,23.15-13.84   c6.3-2.5,12.56-5.22,17.29-8.23c13.3-8.45,25.98-35.68,27.07-40.54c0.39-1.69,0.55-2.71,0.54-3.42v-0.02   c-0.03-1.31-0.68-1.5-1.79-2.82c-0.54-0.64-2.16-0.42-4.14,0.19c-5.74,1.75-10.58,5.68-13.58,10.87   c-2.77,4.8-7.21,10.81-12.64,12.26c-9.39,2.51-8.61,4.07-12.08,13.61c-3.46,9.55-12.19,11.11-23.14,22.38   C969.68,846.77,971.09,905.84,971.09,905.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1003.1,831.21c6.3-2.5,12.56-5.22,17.29-8.23c13.3-8.45,25.98-35.68,27.07-40.54   c0.39-1.69,0.55-2.71,0.54-3.42c-0.04,0.32-0.66,4.63-7.59,7.49c-7.19,2.97-8.6,2.97-9.54,7.51c-0.94,4.54-1.73,9.39-5.48,10.33   c-3.76,0.94-6.1-3.29-9.07,3.6c-2.98,6.88-4.39,9.23-7.13,10.17c-2.73,0.94-4.81-0.47-5.42,4.85   C1003.41,826.24,1003.2,829.32,1003.1,831.21z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M963.82,967.05c17.09,0,24.3-13.65,27.14-28.13c-16.75-6.35-37.85-16.53-55.35-31.87    C934.57,917.33,931.2,967.05,963.82,967.05z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.775b946d8f61441706ce878fe6949b5d.svg";
export { ForwardRef as ReactComponent };